module.exports = __webpack_public_path__ + "static/media/Witch.d06dc1d8.jpg";